import { render, staticRenderFns } from "./UpdateMsg.vue?vue&type=template&id=6217e65c"
import script from "./UpdateMsg.vue?vue&type=script&lang=js"
export * from "./UpdateMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports